import React, { useState, useEffect, useRef } from "react";
import { Button, Icon } from "semantic-ui-react";
import { useParams, useHistory } from "react-router-dom";
import { map, size, forEach, every } from "lodash";
import { OrderHistoryItem } from "../../components/Client";
import { PaymentMethodModal } from "../../components/Common";
import { useOrder, useTable, usePayment, usePolling } from "../../hooks";
import { cleanProductCartApi } from "../../api/cart";
import { clearTableAccess } from "../../api/tableAccess";
import { ORDER_STATUS } from "../../utils/constants";
import { getOrderPrice } from "../../utils/order";
import "./OrdersHistory.scss";

export function OrdersHistory() {
  const [idTable, setIdTable] = useState(null);
  const [showTypePayment, setShowTypePayment] = useState(false);
  const [isRequestAccount, setIsRequestAccount] = useState(false);
  const hadPendingPaymentRef = useRef(false);
  const { loading, orders, getOrdersByTable, addPaymentToOrder } = useOrder();
  const { getTableByNumber } = useTable();
  const { tableNumber } = useParams();
  const { createPayment, getPaymentByTable } = usePayment();
  const history = useHistory();

  useEffect(() => {
    (async () => {
      const table = await getTableByNumber(tableNumber);
      const idTableTemp = table[0].id;
      setIdTable(idTableTemp);

      getOrdersByTable(idTableTemp, "", "ordering=-status,-created_at");
    })();
  }, []);

  // Refresco cada 10 s y al volver a primer plano (usePolling: en iOS el
  // setInterval se congelaba con la pantalla bloqueada).
  usePolling(
    async () => {
      getOrdersByTable(idTable, "", "ordering=-status,-created_at", true);

      const response = await getPaymentByTable(idTable);
      if (hadPendingPaymentRef.current && size(response) === 0) {
        cleanProductCartApi();
        clearTableAccess();
        history.push("/");
        return;
      }
      hadPendingPaymentRef.current = size(response) > 0;
      setIsRequestAccount(response);
    },
    10000,
    { enabled: !!idTable }
  );

  useEffect(() => {
    (async () => {
      if (idTable) {
        const response = await getPaymentByTable(idTable);
        hadPendingPaymentRef.current = size(response) > 0;
        setIsRequestAccount(response);
      }
    })();
  }, [idTable]);

  const onCreatePayment = async (paymentType) => {
    setShowTypePayment(false);

    let totalPayment = 0;
    forEach(orders, (order) => {
      totalPayment += getOrderPrice(order);
    });

    const paymentData = {
      table: idTable,
      totalPayment: totalPayment.toFixed(2),
      paymentType,
      statusPayment: "PENDING",
    };

    const payment = await createPayment(paymentData);
    // Si otro comensal de la mesa ya pidió la cuenta (el backend rechaza una
    // segunda pendiente), solo se recarga para mostrar la existente.
    if (!payment?.id) {
      window.location.reload();
      return;
    }
    for await (const order of orders) {
      await addPaymentToOrder(order.id, payment.id);
    }
    window.location.reload();
  };

  const goToMenu = () => history.push(`/client/${tableNumber}`);

  return (
    <div>
      <Button
        icon
        labelPosition="left"
        className="orders-history__back"
        onClick={goToMenu}
      >
        <Icon name="arrow left" />
        Regresar al Menu
      </Button>

      <h1>Historial de pedidos</h1>

      {loading ? (
        <p>Cargando...</p>
      ) : (
        <>
          {size(isRequestAccount) === 0 && (
            <Button
              basic
              primary
              fluid
              icon
              labelPosition="left"
              onClick={goToMenu}
            >
              <Icon name="plus" />
              Agregar mas productos
            </Button>
          )}

          {size(orders) > 0 && (
            <Button
              primary
              fluid
              disabled={
                size(isRequestAccount) === 0 &&
                !every(orders, (order) => order.status === ORDER_STATUS.DELIVERED)
              }
              onClick={() =>
                size(isRequestAccount) === 0 && setShowTypePayment(true)
              }
            >
              {size(isRequestAccount) > 0
                ? "La cuenta ya está pedida"
                : "Pedir la cuenta"}
            </Button>
          )}

          {map(orders, (order) => (
            <OrderHistoryItem key={order.id} order={order} />
          ))}
        </>
      )}

      <PaymentMethodModal
        show={showTypePayment}
        onSelect={onCreatePayment}
        onCancel={() => setShowTypePayment(false)}
      />
    </div>
  );
}
